"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "alseno": {
    "19e16efc": [{
      "hkey": "7f29a2e2",
      "slug": "chiaravalle-della-colomba",
      "name": "Chiaravalle della Colomba",
      "primary": true,
      "skipSearch": false
    }],
    "chiaravalle-della-colomba-lusurasco": [{
      "hkey": "7f29a2e2",
      "slug": "chiaravalle-della-colomba",
      "name": "Chiaravalle della Colomba",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;